import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@airtel/air-design-system';
export var SearchComponent = props => {
  var voiceEnabled = props.voiceEnabled,
    onValidInput = props.onValidInput,
    onChangeText = props.onChangeText,
    onClear = props.onClear,
    placeholder = props.placeholder,
    maxLength = props.maxLength,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    _props$showLoader = props.showLoader,
    showLoader = _props$showLoader === void 0 ? false : _props$showLoader,
    _props$showClearButto = props.showClearButton,
    showClearButton = _props$showClearButto === void 0 ? true : _props$showClearButto,
    _props$state = props.state,
    state = _props$state === void 0 ? 'focused' : _props$state,
    _props$hintText = props.hintText,
    hintText = _props$hintText === void 0 ? '' : _props$hintText;
  return voiceEnabled ? _jsx(Input, Object.assign({
    multiline: false
  }, props)) : _jsx(Input, Object.assign({
    onClearButtonPress: onClear,
    onSubmitEditing: onValidInput,
    onChangeText: onChangeText,
    showClearButton: showClearButton,
    returnKeyType: "search",
    placeholder: placeholder,
    size: "md",
    autoFocus: true,
    state: state,
    theme: "light",
    value: value,
    multiline: false,
    maxLength: maxLength,
    hintText: hintText,
    showLoader: showLoader
  }, props));
};